import React, { useState } from "react";

const DomainCount = () => {
  const [counts, setCounts] = useState(null);

  const emailGroup = (email) => {
    const e = email.toLowerCase();

    if (e.includes("@gmail.") || e.includes("@googlemail.")) return "Gmail";

    if (e.includes("@yahoo.") || e.includes("@ymail.") || e.includes("@rocketmail."))
      return "Yahoo";

    if (
      e.includes("@aol.") ||
      e.includes("@aim.") ||
      e.includes("@love.com") ||
      e.includes("@games.com") ||
      e.includes("@wow.com")
    )
      return "AOL";

    if (
      e.includes("@outlook.") ||
      e.includes("@hotmail.") ||
      e.includes("@live.") ||
      e.includes("@msn.") ||
      e.includes("@office.") ||
      e.includes("@onmicrosoft.")
    )
      return "Outlook";

    if (e.includes("@icloud.") || e.includes("@mac.") || e.includes("@me."))
      return "Apple";

    if (e.includes("@comcast.") || e.includes("@xfinity."))
      return "Comcast";

    if (e.includes("@charter.") || e.includes("@spectrum."))
      return "Charter";

    if (
      e.includes("@att.") ||
      e.includes("@bellsouth.") ||
      e.includes("@sbcglobal.") ||
      e.includes("@swbell.")
    )
      return "AT&T";

    if (e.includes("@verizon.") || e.includes("@yahoo.verizon."))
      return "Verizon";

    return "Other";
  };

  const processCSV = (text) => {
    const lines = text.split("\n").map((l) => l.trim());
    const header = lines[0].split(",");

    const emailColIndex = header.findIndex((h) =>
      h.toLowerCase().includes("email")
    );

    if (emailColIndex === -1) {
      alert("No email column found.");
      return;
    }

    const result = {
      Gmail: 0,
      Yahoo: 0,
      AOL: 0,
      Outlook: 0,
      Apple: 0,
      Comcast: 0,
      Charter: 0,
      "AT&T": 0,
      Verizon: 0,
      Other: 0,
    };

    for (let i = 1; i < lines.length; i++) {
      const row = lines[i].split(",");
      const email = row[emailColIndex];
      if (!email) continue;

      const group = emailGroup(email.trim());
      result[group]++;
    }

    setCounts(result);
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      processCSV(event.target.result);
    };
    reader.readAsText(file);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Email Domain Counter</h2>

      <input type="file" accept=".csv" onChange={handleUpload} />

      {counts && (
        <div style={{ marginTop: "20px" }}>
          <table border="1" cellPadding="8">
            <thead>
              <tr>
                <th>Group</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(counts).map((k) => (
                <tr key={k}>
                  <td>{k}</td>
                  <td>{counts[k]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DomainCount;
